import React from "react";
import blendLogo from "../../assets/images/blendLogo.png";
import bannerRightImage from "../../assets/svg/mainSection.svg";
import { useNavigate } from "react-router-dom";

const Error = () => {
  let navigate = useNavigate();

  const styles = {
    mainWrapper: "min-w-screen h-screen flex items-center p-5 lg:p-20 overflow-hidden relative",
    cardContainer: "flex-1 min-h-full min-w-full rounded-3xl bg-white shadow-2xl p-10 lg:p-20 text-gray-800 relative md:flex items-center text-center md:text-left",
    h1Heading: "font-black uppercase text-3xl lg:text-5xl text-primary mb-10",
    buttonStyle: "text-lg  outline-none focus:outline-none transform transition-all hover:scale-110 text-tertiary font-bold",
    primaryStyle: "w-64 md:w-96 h-96 md:h-full bg-primary bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform",
    secondaryStyle: "w-96 h-full bg-secondary bg-opacity-20 absolute -bottom-96 right-64 rounded-full pointer-events-none -rotate-45 transform",
    tertiaryStyle: "w-96 h-full bg-tertiary bg-opacity-20 absolute -top-[26rem] left-36 rounded-full pointer-events-none -rotate-45 transform",
  };

  return (
    <>
      <div className={styles.mainWrapper}>
        <div className={styles.cardContainer}>
          <div className="w-full md:w-1/2">
            <div className="mb-10 lg:mb-15">
              <img
                src={blendLogo}
                alt="Blend IT Logo"
                className="w-20 h-10 sm:w-28 sm:h-12"
              />
            </div>
            <div className="mb-10 md:mb-20 text-gray-600 ">
              <h1 className={styles.h1Heading}>You seem to be lost!</h1>
              <p className="text-secondary font-bold">
                The page you're looking for isn't available.
              </p>
              <p className="text-secondary font-bold">
                Try searching again or use the Go Back button below.
              </p>
            </div>
            <div className="mb-20 md:mb-0">
              <button
                className={styles.buttonStyle}
                onClick={() => navigate(-1)}
              >
                <i className="mdi mdi-arrow-left mr-2"></i>Go Back
              </button>
            </div>
          </div>
          <div className="w-full md:w-1/2 text-center">
            <img
              src={bannerRightImage}
              alt="Banner"
              className="w-full h-auto md:h-full"
            />
          </div>
        </div>
        <div className={styles.primaryStyle}></div>
        <div className={styles.secondaryStyle}></div>
        <div className={styles.tertiaryStyle}></div>
      </div>
    </>
  );
};

export default Error;
